import { Box, BoxProps } from '@chakra-ui/react';
import DOMPurify from 'isomorphic-dompurify';
import { marked } from 'marked';
import React, { FunctionComponent, useEffect, useState } from 'react';

interface AdvancedTextProps extends Omit<BoxProps, 'children'> {
  content?: string;
  className?: string;
}

export const AdvancedText: FunctionComponent<AdvancedTextProps> = ({
  content,
  className = 'advanced-text',
  ...boxProps
}) => {
  const [htmlContent, setHtmlContent] = useState<string>('');

  useEffect(() => {
    const processMarkdown = async () => {
      if (content) {
        try {
          // Convert Markdown → HTML using async marked API
          const html = await marked.parse(content);
          const sanitizedHtml = DOMPurify.sanitize(html);
          setHtmlContent(sanitizedHtml);
        } catch (error) {
          console.error('Error processing markdown in AdvancedText:', error);
          setHtmlContent('');
        }
      } else {
        setHtmlContent('');
      }
    };

    processMarkdown();
  }, [content]);

  // Don't render anything if there's no content
  if (!htmlContent) {
    return null;
  }

  return <Box className={className} dangerouslySetInnerHTML={{ __html: htmlContent }} {...boxProps} />;
};
